import { render, staticRenderFns } from "./CardTransfer.vue?vue&type=template&id=21b97e11&scoped=true&"
import script from "./CardTransfer.vue?vue&type=script&lang=js&"
export * from "./CardTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b97e11",
  null
  
)

export default component.exports